export default {
    disabled: 'This trend cannot be activated because the associated mega-trend is inactive',
    CompanyMegatrend: {
        active: 'The status of the mega-trend is active',
        inactive: 'The status of the mega-trend is inactive',
        success: 'The status of the trend has been successfully changed. The process may take a few minutes.'
    },
    CompanyMacrotrend: {
        active: 'The status of the macro-trend is active',
        inactive: 'The status of the macro-trend is inactive'
    }
}
